import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { SuggestionCard } from "./SuggestionCard";
import { Col, Row, Spinner, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import "./Suggestion.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  suggestionList,
  deleteSuggestion,
} from "../../../redux/actions/dbactions/facilityActions";
import { Header } from "../../Header";
import PayoutIcon from "../../../../assets/PayoutIcon";
import { DeleteModal } from "../Modals/DeleteModal";

const Suggestion = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const { suggestion, isLoading } = useSelector((state) => state.facilitylist);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [deletemodal, setDeletemodal] = useState(false);

  useEffect(() => {
    console.log("useEffect ->", refresh);
    if (refresh) {
      dispatch(suggestionList());
      setRefresh(false);
    }
  }, [dispatch, suggestion]);

  const handleSubmitSuggestions = () => {
    // Dispatch action with startDate and endDate
    //console.log("startDate", startDate);
    //console.log("endDate", e.target.value);
    //console.log("submitting selectedProfiles", selectedProfiles);

    //dispatch(createSuggestion({ payoutlist: selectedProfiles }));
    setRefresh(true);
  };
  //console.log("selectedProfiles", selectedProfiles);
  //const filteredValues = payout?.usr?.rec[0]?.daily_orders;
  const filteredValues = suggestion?.usr?.rec;

  const handleDelete = () => {
    if (selectedId) {
      dispatch(deleteSuggestion(selectedId));
      setRefresh(true);
      setDeletemodal(false);
    }
  };
  const handleDeleteShow = (service_pro_sgstn_id, provider_name) => {
    setDeletemodal(true);
    setRefresh(false);
    setSelectedId(service_pro_sgstn_id);
    setSelectedTitle(provider_name);
  };

  //console.log("filteredValues", filteredValues);
  return (
    <div>
      <Header pageTitle="Suggestion Details" icon={<PayoutIcon />} />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap m-0">
          Suggestion Details
        </h5>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="sm:px-4 m-0">
        {filteredValues?.length > 0 ? (
          filteredValues?.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <SuggestionCard
                data={item}
                key={item.service_pro_sgstn_id}
                isSelected={selectedProfiles.includes(
                  item.service_pro_sgstn_id
                )}
                handleDeleteShow={() =>
                  handleDeleteShow(
                    item.service_pro_sgstn_id,
                    item.provider_name
                  )
                }
                dispatch={dispatch}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Suggestions to display</p>
          </Col>
        )}
      </Row>
      <DeleteModal
        handleDelete={() => {
          handleDelete(selectedId);
          setDeletemodal(false);
        }}
        show={deletemodal}
        handleClose={() => setDeletemodal(false)}
        selectedId={selectedId}
        selectedTitle={selectedTitle}
      />
    </div>
  );
};

export default withRouter(Suggestion);
